<script setup>
import { ref, computed } from "vue"

const props = defineProps({
  id: {
    type: String,
    default: null
  },
  for: {
    type: String,
    default: null
  },
  enabled: {
    type: Boolean,
    default: true
  },
  required: {
    type: Boolean,
    default: false
  },
});
</script>

<template>
  <!-- :required="!!props.required" -->
  <label :for="props.for" :id="props.id" class="label" :class="{ 'label-inactive': !props.enabled }"><slot /></label>
</template>

<style scoped>
.label {
  @apply block mb-2 text-sm font-medium text-gray-900 dark:text-white;
}

.label-inactive {
  @apply text-gray-400;
}
</style>